import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  BooleanField,
  ReferenceField,
  ArrayField,
  NumberField,
  BooleanInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  // RichTextInput,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  Create,
  Show,
  SimpleShowLayout,
  FormDataConsumer,
  useRecordContext,
} from 'react-admin'

import { Paper } from '@mui/material'
import { CustomRichTextInput } from '../components/CustomRichTextInput'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ExamList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <BooleanInput key="filter-isManual" source="isManual" />,
      <BooleanInput key="filter-isTest" source="isTest" />,
      <BooleanInput
        key="filter-isAdminConfirmationRequired"
        source="isAdminConfirmationRequired"
      />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isManual" />
      <NumberField source="minimumPoints" />
      <BooleanField source="isTest" />
      <BooleanField source="isAdminConfirmationRequired" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const ExamEdit = () => (
  <Edit>
    <SimpleForm>
      {/* <CustomRichTextInput source="description" />*/}
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isManual" />
      <FormDataConsumer>
        {({ formData }) =>
          formData?.isManual ? (
            <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
              <ArrayInput source="questions" fullWidth>
                <SimpleFormIterator
                  fullWidth
                  getItemLabel={(index) => `#${index + 1}`}
                  sx={{
                    // Keep the item label from growing and colliding with iterator action buttons
                    '& .RaSimpleFormIterator-index': {
                      display: 'block !important',
                      width: '4ch',
                      minWidth: '4ch',
                      maxWidth: '4ch',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                    '@media (max-width: 899.95px)': {
                      '& .RaSimpleFormIterator-index': {
                        display: 'block !important',
                      },
                    },
                    // Inputs area becomes 1col on mobile, 2col on big screens
                    '& .RaSimpleFormIterator-form': {
                      display: 'grid',
                      gridTemplateColumns: {
                        xs: '1fr',
                        // md: 'repeat(2, 1fr)',
                      },
                      gap: 1,
                      alignItems: 'flex-start',
                      width: '100%',
                      pt: 1.5,
                      flex: '1 1 auto',
                      minWidth: 0,
                    },
                    '& .RaSimpleFormIterator-action': {
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <ReferenceInput source="questionId" reference="questions" />
                </SimpleFormIterator>
              </ArrayInput>
            </Paper>
          ) : (
            <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
              <ArrayInput source="questionsConfigs" fullWidth>
                <SimpleFormIterator
                  fullWidth
                  getItemLabel={(index) => `#${index + 1}`}
                  sx={{
                    // Keep the item label from growing and colliding with iterator action buttons
                    '& .RaSimpleFormIterator-index': {
                      display: 'block !important',
                      width: '4ch',
                      minWidth: '4ch',
                      maxWidth: '4ch',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                    '@media (max-width: 899.95px)': {
                      '& .RaSimpleFormIterator-index': {
                        display: 'block !important',
                      },
                    },
                    // Inputs area becomes 1col on mobile, 2col on big screens
                    '& .RaSimpleFormIterator-form': {
                      display: 'grid',
                      gridTemplateColumns: {
                        xs: '1fr',
                        md: 'repeat(2, 1fr)',
                      },
                      gap: 1,
                      alignItems: 'flex-start',
                      width: '100%',
                      pt: 1.5,
                      flex: '1 1 auto',
                      minWidth: 0,
                    },
                    '& .RaSimpleFormIterator-action': {
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <ReferenceInput source="sectionId" reference="sections" />
                  <NumberInput source="questionNumbers" />
                </SimpleFormIterator>
              </ArrayInput>
            </Paper>
          )
        }
      </FormDataConsumer>
      <NumberInput source="minimumPoints" />
      <BooleanInput source="isTest" />
      <BooleanInput source="isAdminConfirmationRequired" />
      <NumberInput source="timeToProcessInMinutes" />
    </SimpleForm>
  </Edit>
)

export const ExamCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" fullWidth />
      {/* <CustomRichTextInput source="description" /> */}
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isManual" />
      <FormDataConsumer>
        {({ formData }) =>
          formData?.isManual ? (
            <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
              <ArrayInput source="questions" fullWidth>
                <SimpleFormIterator
                  fullWidth
                  getItemLabel={(index) => `#${index + 1}`}
                  sx={{
                    // Keep the item label from growing and colliding with iterator action buttons
                    '& .RaSimpleFormIterator-index': {
                      display: 'block !important',
                      width: '4ch',
                      minWidth: '4ch',
                      maxWidth: '4ch',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                    '@media (max-width: 899.95px)': {
                      '& .RaSimpleFormIterator-index': {
                        display: 'block !important',
                      },
                    },
                    // Inputs area becomes 1col on mobile, 2col on big screens
                    '& .RaSimpleFormIterator-form': {
                      display: 'grid',
                      gridTemplateColumns: {
                        xs: '1fr',
                        // md: 'repeat(2, 1fr)',
                      },
                      gap: 1,
                      alignItems: 'flex-start',
                      width: '100%',
                      pt: 1.5,
                      flex: '1 1 auto',
                      minWidth: 0,
                    },
                    '& .RaSimpleFormIterator-action': {
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <ReferenceInput source="questionId" reference="questions" />
                </SimpleFormIterator>
              </ArrayInput>
            </Paper>
          ) : (
            <Paper sx={{ p: 2, mt: 2, mb: 2, width: '100%' }}>
              <ArrayInput source="questionsConfigs" fullWidth>
                <SimpleFormIterator
                  fullWidth
                  getItemLabel={(index) => `#${index + 1}`}
                  sx={{
                    // Keep the item label from growing and colliding with iterator action buttons
                    '& .RaSimpleFormIterator-index': {
                      display: 'block !important',
                      width: '4ch',
                      minWidth: '4ch',
                      maxWidth: '4ch',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                    '@media (max-width: 899.95px)': {
                      '& .RaSimpleFormIterator-index': {
                        display: 'block !important',
                      },
                    },
                    // Inputs area becomes 1col on mobile, 2col on big screens
                    '& .RaSimpleFormIterator-form': {
                      display: 'grid',
                      gridTemplateColumns: {
                        xs: '1fr',
                        md: 'repeat(2, 1fr)',
                      },
                      gap: 1,
                      alignItems: 'flex-start',
                      width: '100%',
                      pt: 1.5,
                      flex: '1 1 auto',
                      minWidth: 0,
                    },
                    '& .RaSimpleFormIterator-action': {
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <ReferenceInput source="sectionId" reference="sections" />
                  <NumberInput source="questionNumbers" />
                </SimpleFormIterator>
              </ArrayInput>
            </Paper>
          )
        }
      </FormDataConsumer>
      <NumberInput source="minimumPoints" />
      <BooleanInput source="isTest" />
      <BooleanInput source="isAdminConfirmationRequired" />
      <NumberInput source="timeToProcessInMinutes" />
    </SimpleForm>
  </Create>
)

const ConditionalQuestionsField = () => {
  const record = useRecordContext()
  return record?.isManual ? (
    <ArrayField source="questions">
      <Datagrid>
        <ReferenceField source="questionId" reference="questions" />
      </Datagrid>
    </ArrayField>
  ) : (
    <ArrayField source="questionsConfigs">
      <Datagrid>
        <ReferenceField source="sectionId" reference="sections" />
        <NumberField source="questionNumbers" />
      </Datagrid>
    </ArrayField>
  )
}

export const ExamShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isManual" />
      <ConditionalQuestionsField />
      <NumberField source="minimumPoints" />
      <BooleanField source="isTest" />
      <BooleanField source="isAdminConfirmationRequired" />
      <NumberField source="timeToProcessInMinutes" />
    </SimpleShowLayout>
  </Show>
)
